/*
 * pdp-viewers.js — "N people are viewing this right now" social-proof counter.
 * The number (bounded 10–92) is driven by IST time-of-day so it reads as real:
 * quiet overnight (1–6am), building through the day, peaking in the evening.
 * Seeded per product so each page holds a steady baseline, with a gentle live
 * drift every few seconds. Purely cosmetic — no real analytics.
 */
(function () {
  var MIN = 10, MAX = 92;

  // IST hour (UTC + 5:30), independent of the shopper's own timezone.
  function istHour() {
    var ist = new Date(Date.now() + (5 * 60 + 30) * 60 * 1000);
    return ist.getUTCHours();
  }

  // Traffic band per IST hour — all inside 10..92.
  function bandForHour(h) {
    if (h >= 1 && h < 6) return [10, 24];   // deep night — fewest
    if (h >= 6 && h < 9) return [18, 38];   // early morning
    if (h >= 9 && h < 12) return [34, 58];  // morning
    if (h >= 12 && h < 17) return [44, 70]; // afternoon
    if (h >= 17 && h < 21) return [60, 92]; // evening peak
    if (h >= 21 && h < 24) return [40, 66]; // late evening
    return [24, 44];                        // midnight (0–1am)
  }

  // Deterministic 0..1 from a seed so a product's baseline is stable per hour.
  function seededUnit(seed) {
    var x = Math.sin(seed * 12.9898 + istHour() * 78.233) * 43758.5453;
    return x - Math.floor(x);
  }

  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  // Popularity → 0..1. `pop` is a sales-count proxy (custom.sales_rating_count, else a
  // tag heuristic). Log-normalise then bias with a power curve so it follows 80/20 —
  // only the top sellers pull a high viewer count; the long tail stays quiet.
  function popFactor(pop) {
    var f = Math.min(1, Math.log(pop + 1) / Math.LN10 / 2.4); // pop~250→~1, ~15→~0.43, 0→0
    return Math.pow(Math.max(0, f), 1.7);
  }

  function init(el) {
    var out = el.querySelector('[data-viewers-count]');
    if (!out) return;
    var seed = parseInt(el.getAttribute('data-seed'), 10) || 7;
    var available = el.getAttribute('data-available') !== '0';
    var pf = popFactor(parseFloat(el.getAttribute('data-popularity')) || 0);

    // Out of stock → almost nobody's looking: a stable 0–3 with a tiny drift.
    if (!available) {
      var oos = Math.floor(seededUnit(seed) * 4); // 0..3
      out.textContent = oos;
      setInterval(function () {
        oos = clamp(oos + (Math.random() < 0.3 ? (Math.random() < 0.5 ? -1 : 1) : 0), 0, 3);
        out.textContent = oos;
      }, 6000);
      return;
    }

    function band() { return bandForHour(istHour()); }
    // Blend the hour's band with popularity: unpopular products sit near MIN, popular
    // ones reach the band's top.
    function scaled() {
      var b = band();
      var raw = b[0] + seededUnit(seed) * (b[1] - b[0]);
      var v = MIN + (raw - MIN) * (0.18 + 0.82 * pf);
      return clamp(Math.round(v), MIN, MAX);
    }

    var value = scaled();
    out.textContent = value;

    // Gentle live drift toward the (popularity-scaled) target.
    setInterval(function () {
      var target = scaled();
      var step = value < target ? 1 : (value > target ? -1 : (Math.random() < 0.5 ? -1 : 1));
      value = clamp(value + step, MIN, MAX);
      out.textContent = value;
    }, 4000 + Math.floor(seededUnit(seed + 1) * 2500));
  }

  function boot() { document.querySelectorAll('[data-pdp-viewers]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
